import React from "react";
import { useForm } from "react-hook-form";
import { FormContainer, RowContainer } from "./Container";
import { Form } from "reactstrap";
import InputSearch from "./InputSearch";
import SubmitButton from "./SubmitButton";
import Selects from "./Selects";
import { useSelector, useDispatch } from "react-redux";
import { updateSearchFilters } from "../../../../../../../../../actions/search";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { buildSearchQueryString } from "../../../../../../../../SearchPage";

const mappedInputNames = {
  forSale: {
    minPrice: "minForSale",
    maxPrice: "maxForSale",
  },
  forRent: {
    minPrice: "minRent",
    maxPrice: "maxRent",
  },
};

const TabForm = ({ history, searchConfig, sectionDetails, searchType }) => {
  const filters = useSelector((state) => state.search.filters);
  const { register, handleSubmit, control, setValue } = useForm({
    defaultValues: {
      minPrice:
        filters?.Criteria?.[mappedInputNames[searchType].minPrice] ?? "",
      maxPrice:
        filters?.Criteria?.[mappedInputNames[searchType].maxPrice] ?? "",
      minBeds: filters?.Criteria?.minBeds ?? "",
      minBaths: filters?.Criteria?.minBaths ?? "",
    },
  });
  const dispatch = useDispatch();

  const submitHandler = handleSubmit((data) => {
    let criteria = { ...filters.Criteria };
    const inputs = Object.entries(data);
    const getFieldName = (fieldName) =>
      mappedInputNames[searchType]?.[fieldName] ?? fieldName;

    const emptyInputs = inputs
      .filter(([, fieldValue]) => !Boolean(fieldValue))
      .map(([fieldName]) => getFieldName(fieldName));

    const filledInputs = Object.fromEntries(
      inputs
        .filter(([, fieldValue]) => Boolean(fieldValue))
        .map(([fieldName, fieldValue]) => [
          getFieldName(fieldName),
          parseInt(fieldValue, 10) || fieldValue,
        ])
    );

    criteria = Object.entries(criteria)
      .filter(([fieldName]) => !emptyInputs.includes(fieldName))
      .reduce(
        (acc, [fieldName, fieldValue]) => ({ ...acc, [fieldName]: fieldValue }),
        {}
      );
    const types = {
      forSale: searchType === "forSale",
      forRent: searchType === "forRent",
    };
    dispatch(
      updateSearchFilters({
        ...filters,
        Criteria: { ...criteria, ...filledInputs, ...types },
      })
    );

    history.push(
      `/search/public/${buildSearchQueryString({
        Criteria: { ...criteria, ...filledInputs, ...types },
      })}`
    );
  });

  return (
    <Form onSubmit={submitHandler}>
      <FormContainer>
        <RowContainer>
          <InputSearch
            placeholder={sectionDetails.form.inputSearchPlaceholder}
            searchConfig={searchConfig}
          />
        </RowContainer>
        <Selects
          propertyDetails={searchConfig?.PropertyDetails}
          register={register}
          control={control}
          setValue={setValue}
          searchType={searchType}
        />
      </FormContainer>
      <SubmitButton>{sectionDetails.form.submitButton}</SubmitButton>
    </Form>
  );
};

TabForm.propTypes = {
  searchConfig: PropTypes.object,
  sectionDetails: PropTypes.object,
  searchType: PropTypes.oneOf(["forSale", "forRent"]),
};

TabForm.defaultProps = {
  searchConfig: {},
  sectionDetails: {},
  searchType: "forSale",
};

export default withRouter(TabForm);
